<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Auto-Activation For New Versions
                <p class='text-caption text-italic'>Applies to: {{ appliesToText }}</p>
            </div>

            <p>
                The automated activation feature makes the process
                of activating your software easier and faster. If one of the following scenarios
                applies you can successfully use this new auto-activation feature:
            </p>
            <ul class='bulletList'>
                <li>
                    You have an <span class='text-weight-medium'>newer software version</span> with an <span class='text-weight-medium'>active subscription</span>,
                    and you are still using the same computer; or
                </li>
                <li>
                    You have just purchased the program and want to apply the activation code
                    to your software; or
                </li>
                <li>
                    You already have a license and just need to retrieve the activation
                    code again on the same computer.
                </li>
            </ul>
            <p>
                <div class='text-subtitle'>
                    Instructions
                </div>
                Once you have the newer version of software installed, follow the steps below to
                activate your license.
                If you need the setup file to install the software, go to the <router-link to='/Download/LoopCAD'>
                    downloads page.
                </router-link>
            </p>
            <ol class='bulletList'>
                <li>
                    <span class='text-weight-medium'>Run the new software version on the computer that you want activated.</span>
                </li>
                <li>
                    If the <span class='text-weight-medium'>Activation</span> form does not automatically open, click the <span class='text-weight-medium'>Activate</span>
                    link.
                    <p>
                        <img id='ActivateImg' class='img-fit q-mt-md' style="border: 1px solid lightgrey" :src="require('@/assets/img/help/ActivateInstructions.png')"
                             alt='Activation Instructions' />
                    </p>
                </li>
                <li>
                    Now click the green <span class='text-weight-medium'>Update Activation</span> button.<p>
                        <img id='UpdateImg' class='img-fit q-mt-md' style="border: 1px solid lightgrey" :src="require('@/assets/img/help/UpdateInstructions.png')"
                             alt='Update Instructions' />
                    </p>
                </li>
                <li>Complete the login when prompted.</li>
                <li>
                    The activation code will be generated and automatically applied to your computer.
                    Just click <span class='text-weight-medium'>OK</span> after it is completed.
                </li>
            </ol>
            <br />
            <hr />
            <p class='text-caption'>
                Note that the earlier version(s) of your software will not be automatically removed
                when
                you install the latest - multiple versions can exist on the same computer. At any
                time you can remove
                the previous version(s) by using Windows uninstall feature (Control Panel
                | Programs
                and Features).
            </p>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'auto-activation',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year + ', '
                    + productLines.PlumbingCAD.name + ' ' + productLines.PlumbingCAD.year
            }
        }
    }
</script>
